export default "__VITE_ASSET__6ea42a2c__"